import React from 'react';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';

import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const CommerceOption = Atom.createRender(
  ({attributes, classes, context, data, generateAttributes, renderChild}) => {
    return (
      <div {...generateAttributes(attributes, classes)} role="group">
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child, context)
        )}
      </div>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Option',
  showEmpty: false,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Dynamo'), iconName('CollectionItem')),
  },
  constraints: {
    pinToParent: true,
    ancestors: [
      {
        is: [
          'CommerceAddToCartOptionList',
          'CommerceAddToCartOptionListWithSelectorTypes',
        ],
        name: 'Option List',
        rule: 'AtLeastOne',
      },
    ],
    descendants: [
      {is: 'CommerceAddToCartOptionSelect', rule: 'ExactlyOne'},
      {is: 'CommerceAddToCartOptionPillGroup', rule: 'ZeroOrOne'},
    ],
  },
  render: CommerceOption,
  fields: {children: TListOfElement},
});

export default config;
